import { gql } from '__generated__';

export const GET_ALL_TENANT_FEATURE_FLAGS = gql(/* GraphQL */ `
  query GetAllTenantFeatureFlags($input: GetFeatureFlagsInput!) {
    getFeatureFlags(input: $input) {
      featureFlags {
        key
        value {
          status
        }
      }
    }
  }
`);
